/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum UserRole {
  Admin = "Admin",
  Client = "Client",
  Employee = "Employee",
}

export interface CreateShopInput {
  lbcId: string;
  name: string;
  categoryName?: string | null;
  siren?: string | null;
  phone?: string | null;
  isMobile: boolean;
  slogan?: string | null;
  website_url?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: string | null;
  departmentId?: number | null;
  lat?: number | null;
  lng?: number | null;
}

export interface CreateUserInput {
  firstname: string;
  lastname: string;
  email: string;
  password: string;
  role: UserRole;
}

export interface DepartmentsFiltersInput {
  search?: string | null;
  code?: string | null;
}

export interface LoginAsInput {
  email: string;
}

export interface LoginInput {
  email: string;
  password: string;
}

export interface RegionsFiltersInput {
  search?: string | null;
}

export interface ShopCategoriesFiltersInput {
  search?: string | null;
}

export interface ShopsFiltersInput {
  search?: string | null;
  departmentId?: number | null;
  regionId?: number | null;
  categoryId?: number | null;
  orderByMembersCount?: string | null;
  orderByRating?: string | null;
  orderByAdsCount?: string | null;
  orderByCity?: string | null;
  orderByCreatedAt?: string | null;
}

export interface UpdateShopInput {
  lbcId?: string | null;
  name?: string | null;
  categoryName?: string | null;
  siren?: string | null;
  phone?: string | null;
  isMobile?: boolean | null;
  slogan?: string | null;
  website_url?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: string | null;
  departmentId?: number | null;
  lat?: number | null;
  lng?: number | null;
}

export interface UpdateUserInput {
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
  password?: string | null;
  role?: UserRole | null;
}

export interface UsersFiltersInput {
  search?: string | null;
  role?: UserRole | null;
  roles?: UserRole[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
